/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 16:35:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorMaintenancePage/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { request_getMaintenancePage } from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const CloneBtn = (props) => {
  const params: any = useParams();
  const { uuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      request_getMaintenancePage({
        //1===true 0===false
        uuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
        isClone: true,
      }),
    );
  };
  return <Button onClick={handleOnClick} disabled={props?.disabled} />;
};
export default CloneBtn;
